/**
 * Created by v-grfore on 05/09/2016.
 * Builds CSS class and id names in a predictive and consistent way.
 * Class Names are defined below in an enum, and return
 */
//import * as _ from "lodash";

/**
 * Add any CSS class here
 */
export enum Names {
  WbsComponent,
  WbsComponent_Box,
  WbsComponent_WbsId,
  WbsComponent_Title,
  WbsComponent_DataLabel,
  WbsComponent_ToggleSwitchBox,
  WbsComponent_ToggleSwitch,
  AddWbsComponentMenu,
  WbsEdge
}

export interface ClassAndIdNames {
  className: string;
  idName: string;
}

export class CssClassAndIdNames {
  public static getClassName(cssClassName: Names): string {
    //let a: string = _.camelCase(Names[cssClassName]);
    return camelize(Names[cssClassName]);
  }

  public static getIdName(cssClassName: Names|string, id: string): string {
    if (typeof cssClassName === 'string') {
      return `${camelize(cssClassName)}_${id}`;
    } else {
      return `${CssClassAndIdNames.getClassName(cssClassName)}_${id}`;
    }
  }

  public static getClassAndIdNames(cssClassName: Names, id: string): ClassAndIdNames {
    return {
      className: CssClassAndIdNames.getClassName(cssClassName),
      idName: CssClassAndIdNames.getIdName(cssClassName, id)
    };
  }
}

function camelize(str: string) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    })
    .replace(/[\W_]/g, "");
}




// WEBPACK FOOTER //
// ./src/CssClassAndIdNames.ts